module.exports = __webpack_public_path__ + "img/7302315.png";